// @flow
import classNames from 'classnames';
import React from 'react';
import tickIcon from 'assets/images/tick-red.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  title: string,
  subTitle?: string,
  isActive: boolean,
  onClick: () => void,
};

export const ListFilterItem = (props: Props) => {
  const { isActive, onClick, title, subTitle, classname } = props;
  const className = classNames('list-filter-item', classname, {
    active: isActive,
  });

  return (
    <div className={className}>
      <img src={tickIcon} alt={'icon'} />
      <div className={'content'} onClick={onClick}>
        <h4 className="text-wrap">{title}</h4>
        {subTitle && <span>{subTitle}</span>}
      </div>
    </div>
  );
};
